import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";
import { useProducts } from "../../client/product/useProduct";
import Pagination from "../../components/Pagination";
import Spinner from "../../components/Spinner";
import { Heading3 } from "../../components/Typography";
import { COLOR_WHITE } from "../../constants/colors";
import bgGray from "../../images/bg-gray.png";
import Product from "./Product";

const Background = styled.div`
  background-image: url(${bgGray});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  min-height: 50vh;
`;

const Title = styled.h2`
  ${Heading3}
  color: ${COLOR_WHITE};
`;

function ProductSection() {
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoading, isFetching, data } = useProducts(currentPage);

  return (
    <Background>
      <StyledContainer className="py-5">
        <Title className="mb-4">Products</Title>
        {(isLoading || isFetching) && <Spinner animation="border" />}
        {!isLoading && !isFetching && (
          <Row>
            { data?.data && data?.data.map((product, index) => (
              <Col key={product._id} lg={3} xs={6} className="mb-4" style={{ cursor: "pointer" }}>
                <Product product={product} isEven={index % 2 === 0} />
              </Col>
            ))}
          </Row>
        )}
        {!isLoading && !isFetching && (
          <Pagination currentPage={currentPage} totalItems={data?.total ?? 0} onChangePage={setCurrentPage} />
        )}
      </StyledContainer>
    </Background>
  );
}

export default ProductSection;
